import ApplicationSerializer from 'frontend-payments/serializers/application';

export default class AccountListItemSerializer extends ApplicationSerializer {
  primaryKey = 'account_number';

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey() {
    return 'account-list-item';
  }
}
